export const generateBadge = (productTags) => {
  let flag = false;
  const matchStrings = [
    "Badge_curated1:",
    "Badge_curated:",
  ];

  let finalBadge = null;
  let curatedBadge = '';

  // Will loop through all tags and check if categories.lvl2 exists first, if it doesn't exist, will loop all tags again and check for categories.lvl1, finally same will be done for categories.lvl0 if lvl1 doesn't exist
  // As soon as a matching category is found, breadcrumb data will be returned and loops will be broken
  if (productTags) {
    for (let i = 0; i < matchStrings.length; i++) {
      for (let j = 0; j < productTags.length; j++) {
        if (productTags[j].startsWith(matchStrings[i])) {
          finalBadge = productTags[j]
            .replace(matchStrings[i], "");
            if(matchStrings[i] === 'Badge_curated1:') {
              //If there is an array of badge_curated1 tags then selling fast tag supersedes all other tags
              //Tag has lowercase 'f' , FE should be displayed with 'F'
              if(productTags.includes("Badge_curated1:Selling fast")){
                curatedBadge = "Selling Fast";
              } else {
                curatedBadge = finalBadge;
              }
              flag = true
            } else if(matchStrings[i] === 'Badge_curated:') {
              curatedBadge = finalBadge;
              flag = true;
            }
        }
        if(flag) break;
      }
      if(flag) break;
    }
  }
  return curatedBadge.trim();
};

// transforms the tags in the format 
// which we receive from Algolia for PLPs
// It transforms the 'tagName:tagValue' format into key-value json object
export const generateNamedTags = async (arr) => {
    return await arr?.reduce((result, item) => {
      const [key, value] = item.split(':');
      result[key] = value;  
      return result;
    }, {});
}
